export enum WSO2AuthLocalStorageNames {
  IdToken = 'ass_fund_id_token',
  AccessToken = 'ass_fund_access_token',
  RedirectUri = 'ass_fund_redirectUri'
}